import { useEffect, useRef } from "react";

/**
 * Scrollt den referenzierten Scroll-Container sanft nach oben, sobald
 * `isSubmitted` `true` wird — damit das oben gerenderte Quiz-Feedback nach
 * der Validierung sichtbar ist und nicht oberhalb des Sichtbereichs versteckt
 * bleibt (ILP-2790).
 *
 * Der Effekt feuert nur beim Übergang nach `true`. Wird `isSubmitted` beim
 * Wechsel zur nächsten Frage wieder `false`, passiert nichts.
 */
export const useScrollToTopOnSubmit = <T extends HTMLElement>(
  isSubmitted: boolean
) => {
  const ref = useRef<T>(null);
  useEffect(() => {
    // scrollTo ist in manchen Umgebungen (z. B. jsdom) nicht implementiert.
    if (isSubmitted && typeof ref.current?.scrollTo === "function") {
      ref.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [isSubmitted]);
  return ref;
};
